declare const __APP_VERSION__: string;
declare const __BUILD_TIME__: string;

export const APP_VERSION = __APP_VERSION__;
export const BUILD_TIME = __BUILD_TIME__;

const buildDate = new Date(BUILD_TIME);
const validBuildDate = Number.isFinite(buildDate.getTime());

export const BUILD_LABEL = validBuildDate
  ? new Intl.DateTimeFormat("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    })
      .format(buildDate)
      .replace(",", "")
  : "локальная сборка";

export const BUILD_ID = validBuildDate
  ? `${APP_VERSION}-${BUILD_TIME.replace(/\D/g, "").slice(0, 12)}`
  : `${APP_VERSION}-local`;

export function reloadWithFreshAssets() {
  const url = new URL(window.location.href);
  url.searchParams.set("_refresh", Date.now().toString(36));
  window.location.replace(url.toString());
}

export function runtimeDiagnostics(details?: string) {
  return [
    `Egel Design Planner ${BUILD_ID}`,
    `Online: ${navigator.onLine ? "yes" : "no"}`,
    `Browser: ${navigator.userAgent}`,
    details ? `Details: ${details}` : ""
  ]
    .filter(Boolean)
    .join("\n");
}
